import { PrimaryButton } from 'components';
import styled from 'styled-components';
import { colorTeal, mediaSm } from 'theme/theme-helper-selectors';

export const Content = styled.div`
    padding: 80px 0px;

    @media (${mediaSm}) {
        overflow: hidden;
    }
`;

export const Share = styled.div`
    position: absolute;
    left: 0px;
    bottom: -500px;
    height: 1015px;
    width: 955px;
    background-image: url(/assets/images/free-course/blue-question.svg);
    z-index: -1;
`;

export const Title = styled.h4`
    color: ${({ theme }) => theme.palette.black};
    font-size: 48px;
    font-weight: 400;
    line-height: 48px;
    padding-bottom: 40px;
    text-align: center;
    @media (${mediaSm}) {
        font-size: 36px;
    }
`;

export const SendButton = styled(PrimaryButton)`
    background: linear-gradient(45deg, ${colorTeal} 38.74%, #33ff77 100%);
    padding: 16px 54px;
    border-radius: 8px;
    &:hover {
        color: ${({ theme }) => theme.palette.black};
        box-shadow: 0 12px 40px rgba(21, 190, 164, 0.48);
    }
    &:hover:not(:disabled) {
        background: linear-gradient(45deg, ${colorTeal} 38.74%, #33ff77 100%);
    }
    span {
        color: ${({ theme }) => theme.palette.black};
        font-size: 16px;
        line-height: 16px;
    }
`;

export const SendButton2 = styled.a`
    background: linear-gradient(45deg, ${colorTeal} 38.74%, #33ff77 100%);
    padding: 16px 54px;
    border-radius: 8px;
    color: ${({ theme }) => theme.palette.black};
    font-size: 16px;
    line-height: 16px;
    width: fit-content;
    display: flex;
    align-items: center;
    &:hover {
        color: ${({ theme }) => theme.palette.black};
        background: linear-gradient(45deg, ${colorTeal} 38.74%, #33ff77 100%);
        box-shadow: 0 12px 40px rgba(21, 190, 164, 0.48);
        opacity: 0.8;
    }
`;

export const Text = styled.p`
    padding-top: 24px;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${({ theme }) => theme.palette.black};
    max-width: 600px;
    text-align: center;
`;
